<template>
  <div class="mx-auto" :style="tabWidth">
    <p class="text-sm mb-4 text-grey-600">
      {{ $t('frontend_groovevideo_videos_fileupload_upload') }}
    </p>
    <div class="upload videouploadLoader">
      <vue-dropzone
        id="customdropzone"
        ref="myVueDropzone"
        :options="dropzoneOptions"
        :use-custom-slot="true"
        @vdropzone-complete="chunkUploaded"
        @vdropzone-upload-progress="uploadProgress"
        @vdropzone-total-upload-progress="totalProgress"
        @vdropzone-file-added="fileAdded"
      >
        <div class="dropzone-custom-content">
          <!-- <div
            class="w-24 h-24 rounded-full bg-grey-300 flex items-center justify-center m-auto"
          >
            <img src="../assets/images/videos/upload.png" alt />
          </div>
          <h3 class="mt-6 mb-2 dropzone-custom-title">
            Drag and drop video files to upload
          </h3> -->
          <div
            class="
              border-dashed
              rounded-lg
              bgcolor
              border-grey-100 border
              flex flex-col
              h-40
              justify-center
              items-center
              px-4
            "
          >
            <div class="text-xs subtitle mb-3">
              {{ $t('frontend_groovevideo_videos_fileupload_drag_drop') }}
              <br />
              {{ $t('frontend_groovevideo_videos_fileupload_or') }}
            </div>
            <div
              class="
                w-full
                flex flex-row flex-nowrap
                items-center
                justify-center
              "
            >
              <gd-button primary class="px-4 w-auto mr-2">
                {{ $t('frontend_groovevideo_videos_selectfile') }}
              </gd-button>
            </div>
            <div
              class="
                p-2
                flex flex-row flex-nowrap
                items-center
                justify-center
                text-xs
                subtitle
                text-pink
              "
            >
              {{ $t('frontend_groovevideo_video_size_limit') }}
            </div>
          </div>
        </div>
      </vue-dropzone>
    </div>
    <p class="text-sm text-center mx-auto mt-4">
      <span>
        {{ 'Remaining storage: ' }}
        <strong>
          <span class="text-pink">{{ remaining > 0 ? remaining : 0 }}GB</span> /
          {{ totalStorage ?? 100 }}GB</strong
        >
      </span>
      <br />
      <span
        v-if="showStorageAlert"
        class="
          flex flex-col
          items-center
          justify-center
          text-grey-600
          -ml-2
          mt-4
        "
      >
        <div class="text-red font-semibold text-sm">
          <span
            >{{
              $t('frontend_groovevideo_videos_fileupload_low_sorage_left', {
                add: !hasOwnStorage
                  ? $t('frontend_groovevideo_videos_fileupload_add_own_storage')
                  : '',
              })
            }}
          </span>
        </div>
        <span
          class="text-pink underline cursor-pointer mt-1"
          @click="goToStorageSettings"
          v-if="!hasOwnStorage"
          >{{
            $t('frontend_groovevideo_videos_fileupload_go_to_storage_settings')
          }}</span
        >
      </span>
      <!-- <span v-else class="flex flex-row items-center justify-center text-grey-600 -mt-2">
        <span class="px-4 w-3/4">
          You have used more than 80% of your free storage.<br/> Add your own Storage and Encoder
        </span>
        <gd-button
        class="w-40 p-5"
        @click="goToStorageSettings"
        >
          Go to storage settings
        </gd-button>

      </span> -->
    </p>
    <div v-if="video.video_source" class="flex justify-center mt-6">
      <gd-button @click="sendBack">
        {{ $t('frontend_cancel') }}
      </gd-button>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import Video from '@/models/Video';

export default {
  props: {
    storageId: {
      default() {
        return 0;
      },
    },
    storageFolder: {
      default() {
        return 0;
      },
    },
    encoderId: {
      default() {
        return 0;
      },
    },
    headers: {},
    maxSize: {},
    model: {},
    videoDetails: {},
    totalStorage: {
      default() {
        return 100;
      },
    },
    remaining: {
      default() {
        return 100;
      },
    },
    validateForm: {},
    tabWidth: {},
    hasOwnStorage: {
      default: false,
    },
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      user: null,
      newActivity: {
        status: '',
        msg: '',
      },
      isEnabled: 1,
      btnVisible: '',
      video: this.model,
      videoUploadUrl: `${
        process.env.NODE_ENV === 'development'
          ? 'http://localhost:8000'
          : 'https://upload.gdapis.com'
      }/api/groovevideo`,
      dropzoneOptions: {
        acceptedFiles: '.mp4',
        url: this.getUploadUrl,
        headers: {
          email: this.$store.state.user.email,
          apiKey: this.$store.state.user.api_key,
        },
        chunking: true, // enable chunking
        forceChunking: true, // forces chunking when file.size < chunkSize
        parallelChunkUploads: ['5f0d5c5f6ca1bd0016c4fde4'].includes(
          this.$store.state.user.id
        ), // allows chunks to be uploaded in parallel (this is independent of the parallelUploads option)
        chunkSize: 5000000, // chunk size 1,000,000 bytes (~1MB)
        retryChunks: false, // retry chunks on failure
        retryChunksLimit: 3, // retry maximum of 3 times (default is 3)
        parallelUploads: 1,
        timeout: 99999999,
        maxFiles: 1,
        maxFilesize: this.maxSize,
        autoProcessQueue: false,
        autoQueue: true,
      },
      nextButtonDisabled: true,
    };
  },
  computed: {
    showStorageAlert() {
      const percentage = (this.remaining / this.totalStorage) * 100;
      return percentage <= 20;
    },
    currentUserAllowed() {
      // Check if current user is allowed for testing new features
      const allowedUsers = [
        // '5f0d5d4a6ca1bd0016c5142f',
        '5f0d5c5f6ca1bd0016c4fde4'
        // '9d280130-6f1d-429a-8231-b7d77de8c3c4',
      ];

      return allowedUsers.includes(this.user);
    },
  },
  mounted() {
    this.user = this.$store.state.user.id;
    if (this.videoDetails) {
      this.video = this.videoDetails;
    }
  },
  methods: {
    sendBack() {
      this.$router.push({
        name: 'AddNewVideo',
        params: { id: this.$route.params.id },
      });
    },
    goToStorageSettings() {
      this.$router.push({ name: 'settings', hash: '#ownStorage' });
    },
    getUploadUrl() {
      return `${this.videoUploadUrl}/phpupload`;
    },
    chunkUploaded(response) {
      const res = JSON.parse(response.xhr.response);
      if (res.final === true) {
        this.$emit('uploadProgress', '', 100, '', true);
      } else {
        this.uploadError(true);
        return;
      }
      this.showLoader();
      this.uploadSuccess(res.path);
    },
    async uploadError(uploadFailed = false) {
      const self = this;
      if (!uploadFailed && !self.$route.params.id) {
        const vid = await Video.$find(self.video.id);
        self.video = {
          name: vid.name,
          category_id: vid.category_id,
        };
        await vid.delete();
      }
      self.hideLoader();
      self.newActivity = 'failed';
      self.btnVisible = 'progress100';
      await Swal.fire({
        type: 'error',
        title: 'Error',
        text: 'Cannot upload video. Please try again',
        reverseButtons: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
      });
      self.$emit('updateDisplayUploadbox', false);
      self.createActivity();
      self.$refs.myVueDropzone.removeAllFiles();
      self.$refs.myVueDropzone.enable();
      self.isEnabled = 1;
    },
    async uploadSuccess(s3ObjectLocation) {
      const self = this;
      const files = self.$refs.myVueDropzone.getAcceptedFiles();
      if (files.length) {
        const fileSize = files[0].size;

        const s3UploadSuccessData = await axios.post(
          `${this.videoUploadUrl}/s3upload`,
          {
            vid: self.video.id,
            vName: self.video.name,
            vCategory: self.video.category_id,
            storageId: self.storageId,
            encoderId: self.encoderId,
            folder: self.storageFolder,
            isPaid: true,
            fileLink: s3ObjectLocation.path,
            chunksDetail: s3ObjectLocation,
            fileSize,
          },
          {
            headers: {
              email: this.$store.state.user.email,
              apiKey: this.$store.state.user.api_key,
            },
          }
        );

        const uploadResponse = s3UploadSuccessData.data;

        if (uploadResponse.status == 'uploading') {
          self.newActivity = 'uploading';
          this.btnVisible = 'progress100';
          this.nextButtonDisabled = false;
          self.createActivity();
          this.addVideo();
        } else if (
          uploadResponse.status == 'encoding' ||
          uploadResponse.status == 'processing'
        ) {
          self.$refs.myVueDropzone.disable();
          self.isEnabled = 0;
          self.hideLoader();
          self.newActivity = 'encoding';
          this.btnVisible = 'progress100';
          this.nextButtonDisabled = false;
          self.createActivity();
          this.addVideo();
        } else if (uploadResponse.status == 'uploaded') {
          self.$refs.myVueDropzone.disable();
          self.isEnabled = 0;
          self.hideLoader();
          self.newActivity = 'uploaded';
          this.btnVisible = 'progress100';
          this.nextButtonDisabled = false;
          self.createActivity();
          this.addVideo();
        } else {
          self.uploadError();
        }
      }
    },
    uploadProgress(file, progress, bytesSent) {
      this.$emit('uploadProgress', file, progress, bytesSent);
    },
    totalProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      // console.log(totaluploadprogress, totalBytes, totalBytesSent);
    },
    fileAdded(file) {
      const fileSize = (file.size / (1000 * 1000)).toFixed(1);

      // Validate
      const isValid = this.validateForm();

      // Max File Size Check
      if (fileSize > this.maxSize) {
        // Remove file in case greater than allowed file size
        this.$refs.myVueDropzone.removeFile(file);

        // Show error message
        Swal.fire(
          this.$t('frontend_upload_error'),
          `Files larger than ${this.maxSize}MB are not allowed.`,
          'error'
        );
      } else if (!isValid) {
        // Remove file in case invalid fields
        this.$refs.myVueDropzone.removeFile(file);
      } else {
        const self = this;
        // Timeout lets added file to get queued for processing
        setTimeout(async () => {
          // Check queued file
          if (self.$refs.myVueDropzone.getQueuedFiles().length) {
            const element = self.$el.querySelector('#customdropzone');
            if (element.classList.contains('dz-started')) {
              self.$emit('updateDisplayUploadbox', true);
            }
            if (!this.video.id) {
              await this.createVideo();
            }
            // Initiate file upload
            self.$refs.myVueDropzone.processQueue();
          }
        }, 300);
      }
    },
    async createVideo() {
      // Create Video
      const video = new Video({
        name: this.video.name,
        category: this.video.category_id,
        is_local: 1,
      });
      this.video = (await video.save()).data;
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    createActivity() {
      this.$emit('activityCreated', this.newActivity);
    },
    addVideo() {
      // Redirect only when button is active
      if (!this.nextButtonDisabled) {
        this.$router.push({
          name: 'AddNewVideo',
          params: {
            id: this.video.id,
            activityCreated: this.newActivity,
          },
        });
      }
    },
  },
};
</script>